<p style=" font-weight:semibold !important" class="mb-1 font-light   text-black text-nowrap">
  {{ label }}
</p>

<div
  [class]="
    class + ' flex flex-col text-center items-center w-full h-full relative'
  "
>
  <small class="absolute bottom-[60%] left-[15%] ">40%</small>
  <small class="absolute bottom-[30%] left-[3%]">20%</small>
  <small class="absolute bottom-0 left-0">0%</small>
  <small class="absolute bottom-[60%] right-[15%]">60%</small>
  <small class="absolute bottom-[30%] right-[3%]">80%</small>
  <small class="absolute bottom-0 right-0">100%</small>
  <round-progress
    [current]="getNum()"
    [max]="max"
    [color]="color"
    class="mx-5 mt-auto"
    [radius]="radius"
    [stroke]="stroke"
    [semicircle]="true"
  />
  <div class="flex flex-col absolute bottom-[5%]">
    <p [style]="' font-weight:bold !important;color:'+color" class=" grad-main-color    bg-clip-text  text-md">
      {{ percentage }}%
    </p>
  </div>
</div>
